import React from "react";
import "./projects_table.scss";
import GreenHydrogen from "../../assets/img/accordian_operation/green-hydrogen.png";
import projects_img from "../../assets/img/projects_img.png";


const greenPower = [
  {
    "image": GreenHydrogen,
    "type": "300 MW RTC",
    "location": "Pan India",
    "link": "",
    "capacity": "1000 MW",
    "status": "Under Construction"
  },   {
    "image": GreenHydrogen,
    "type": "100 MW C&I RTC",
    "location": "Pan India",
    "link": "",
    "capacity": "300 MW",
    "status": "Under Construction"
  }
]



export const ProjectsAccordian = () => {
  return (
    <div>
      <section>
        <div className="container">
          <div className="row text-center pos_relative">
            <center>
              <div className="title pt-4">
                <h4>Projects</h4>
              </div>
            </center>
          </div>
          <div className="table-responsive">
            <table className="table table-striped ">
              <thead>
                <tr className="tableRow">
                  <th>S.No</th>
                  <th>Project Image</th>
                  <th>Project Type</th>
                  <th>Location</th>
                  <th>Capacity (MW AC)</th>
                  <th>Project Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  greenPower.map((project, index) => (
                    <tr>
                    <td> {index+1} </td>
                    <th>
                      <img src={project?.image} alt="" />
                    </th>
                    <th>{project?.type}</th>
                    <td>{project?.location}</td>
                    <td>{project?.capacity}</td>
                    <td>{project?.status}</td>
                  </tr>

                  ))
                }
                {/* <tr className="text-center">
                  <td colSpan={6}>
                    *installed capacity of approximately 1 GW of renewables
                    through solar, wind along with third-party storage
                    arrangements
                  </td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectsAccordian;
